import AppLogoIcon from "./app-logo-icon";

export default function AppLogo() {
  return (
    <>
      <div className=" text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-md">
        <AppLogoIcon className="size-62 fill-current text-white" />
      </div>
      <div className="ml-1 grid flex-1 text-left text-md">
        <span className="mb-0.5 truncate leading-tight font-bold text-lg">
          Synapse
        </span>
      </div>
    </>
  );
}
